module.exports = __webpack_public_path__ + "img/hfg_of110122_12k.b97ab4dc.jpg";